/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Phase_1_DescriptionInputs */

const en_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get familiar with the focus tools and find the best way that suit you.`)
};

const ar_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعرّف على أدوات التركيز واعثر على أفضل طريقة تناسبك.`)
};

const de_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Machen Sie sich mit den Fokussierungswerkzeugen vertraut und finden Sie die für Sie am besten geeignete Methode.`)
};

const es_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Familiarízate con las herramientas de concentración y encuentra la mejor manera que se adapte a ti.`)
};

const fr_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Familiarisez-vous avec les outils de concentration et trouvez la meilleure façon qui vous convient.`)
};

const it_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acquisisci familiarità con gli strumenti di concentrazione e trova il modo migliore per te.`)
};

const ja_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中ツールを使いこなし、自分に合ったベストな方法を見つけましょう。`)
};

const ko_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중 툴에 익숙해지고 본인에게 가장 적합한 방법을 찾아보세요.`)
};

const pt_br_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Familiarize-se com as ferramentas de foco e encontre a forma que mais se adéqua a você.`)
};

const ru_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ознакомьтесь с инструментами фокусировки и найдите наиболее подходящий для вас способ.`)
};

const th_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำความคุ้นเคยกับเครื่องมือการโฟกัส และหาวิธีที่เหมาะสมที่สุดสำหรับคุณ`)
};

const tr_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanma araçlarını tanı ve sana en uygun olanı bul.`)
};

const zh_cn_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`熟悉专注工具，找到最适合你的专注方法。`)
};

const zh_tw_starter_challenge_phase_1_description = /** @type {(inputs: Starter_Challenge_Phase_1_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`熟悉專注工具，找到最適合你的專注方法。`)
};

/**
* | output |
* | --- |
* | "Get familiar with the focus tools and find the best way that suit you." |
*
* @param {Starter_Challenge_Phase_1_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_phase_1_description = /** @type {((inputs?: Starter_Challenge_Phase_1_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Phase_1_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_phase_1_description(inputs)
	if (locale === "ar") return ar_starter_challenge_phase_1_description(inputs)
	if (locale === "de") return de_starter_challenge_phase_1_description(inputs)
	if (locale === "es") return es_starter_challenge_phase_1_description(inputs)
	if (locale === "fr") return fr_starter_challenge_phase_1_description(inputs)
	if (locale === "it") return it_starter_challenge_phase_1_description(inputs)
	if (locale === "ja") return ja_starter_challenge_phase_1_description(inputs)
	if (locale === "ko") return ko_starter_challenge_phase_1_description(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_phase_1_description(inputs)
	if (locale === "ru") return ru_starter_challenge_phase_1_description(inputs)
	if (locale === "th") return th_starter_challenge_phase_1_description(inputs)
	if (locale === "tr") return tr_starter_challenge_phase_1_description(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_phase_1_description(inputs)
	return zh_tw_starter_challenge_phase_1_description(inputs)
});